export default "__VITE_ASSET__t9rix0h___";